import React from 'react';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
  const { t } = useTranslation(); // ou juste 'common' selon ton fichier de langue

  return (
    <section className="bg-white dark:bg-slate-950 py-20">
      <div className="container mx-auto flex flex-col lg:flex-row items-center px-6 lg:px-20">
        {/* Texte de la bannière */}
        <div className="lg:w-1/2 text-center lg:text-left mb-10 lg:mb-0 mr-6">
          <h6 className="text-xl font-bold text-blue-600 mb-4">{t('titleAbout')}</h6>
          <h1 className="text-5xl font-bold text-gray-800 dark:text-gray-200 mb-4">
            {t('subTitle')} <span className="text-blue-600">2021</span>
          </h1>
          <p className="text-gray-600 dark:text-gray-400 text-lg mb-6">
            {t('descriptionAbout')}
          </p>
        </div>

        {/* Illustration de la bannière */}
        <div className="lg:w-1/2">
          <img
            src="images/About.png"
            alt="IT Solutions"
            width={500}
            height={500}
            loading="lazy"
            className="rounded-lg shadow-lg"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
